exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.PlainSpec[data-v-435e6e25] {\n  display: flex;\n  max-height: calc(100vh - 48px);\n  width: 50%;\n  margin: 0 auto;\n}\n", ""]);

// exports
